export default {
    //全半角英数漢ひらカナ記号（・ー）
    ZenHankakuEiSuuKanaKanji: '^[0-9０-９a-zA-ZＡ-Ｚａ-ｚぁ-んァ-ヶ一-龠々・ー]*$',
    //全半角英数漢ひらカナ記号（・ー）
    ZenHankakuEiSuuKanaKanjiSpace: '^[0-9０-９a-zA-ZＡ-Ｚａ-ｚぁ-んァ-ヶ一-龠々・ー　 ]*$',
    //全半角英数漢ひらカナ記号（・ー）
    ZenHankakuEiSuuKanaKanjiSpaceSymbol: '^[0-9０-９a-zA-ZＡ-Ｚａ-ｚぁ-んァ-ヶ一-龠々・\\-ー&＆\'’\\,，\\.．　 ]*$',
    //全半角漢ひらカナ記号（・ー）
    ZenHankakuKanaKanji: '^[ぁ-んァ-ヶー一-龠々・ー　 ]+$',
    //住所（全半角英数漢ひらカナ記号（・ー-））
    Address: '^[0-9０-９a-zA-ZＡ-Ｚａ-ｚぁ-んァ-ヶ一-龠々・ー\\-　 ]*$',
    //全角ひらがな
    ZenkakuHiragana: '^[ぁ-ん・ー　 ]+$',
}